import { userTransformer, UserType } from './userTransformer';


export interface UserInfoType {
  user: UserType,
  totalBalance: number,
  rewardBalance: number,
  walletBalance: number,
  verificationRequired: boolean,
  scwalletEnabled: boolean,
}
/**
 * @description
 * transformer for user details in vault api
 * @param data - userDetailsDTO key in vault api
 */
export const userInfoTransformer = (data:UserInfoType) => {
  if (!data) {
    return {};
  }
  const {
    user,
    totalBalance = null,
    rewardBalance = null,
    walletBalance = null,
    verificationRequired = null,
    scwalletEnabled = null,
  } = data;
  return {
    user: userTransformer(user),
    totalBalance,
    rewardBalance,
    walletBalance,
    verificationRequired,
    scwalletEnabled,
  };
};
